<template>
  <div>
    <!--v-show="show"-->
    <div align="right">
      <el-form :inline="true" class="style1">
        <el-form-item>
          <el-button class="el-icon-circle-plus-outline" type="text" @click="dialogVisible = true">
            {{$t("general.add")}}
          </el-button>
        </el-form-item>
      </el-form>
    </div>

    <el-table :data="tableData" highlight-current-row border style="width: 100%; margin-top: 0px" :empty-text="$t('general.empty_data')">

      <el-table-column :label="$t('general.date')" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.date }}</span>
        </template>
      </el-table-column>

      <el-table-column　:label="$t('companyInfo.name')" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.comName }}</span>
        </template>
      </el-table-column>

      <el-table-column　:label="$t('empList.name')" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.empName }}</span>
        </template>
      </el-table-column>

      <el-table-column　label="育児休業開始日" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.leaveStartDate }}</span>
        </template>
      </el-table-column>

      <el-table-column　label="出産日" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.dueDate }}</span>
        </template>
      </el-table-column>

      <el-table-column :label="$t('general.operation')" align="center" width="360">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" icon="el-icon-edit" @click="handleEdit(scope.$index, scope.row)">
            {{$t("general.edit")}}
          </el-button>
          <el-button size="mini" type="danger" icon="el-icon-delete" @click="handleDelete(scope.$index, scope.row)">
            {{$t("general.delete")}}
          </el-button>
          <el-button size="mini" type="success" icon="el-icon-view" @click="printPDF(scope.$index, scope.row)">
            {{$t("general.print")}}
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="pages">
      <el-pagination background :disabled="disablePage" :current-page.sync="currentPage" small layout="prev, pager, next" :page-size="pageSize" :total="total" @current-change="handleCurrentChange">
      </el-pagination>
    </div>

    <!-- adding new -->
    <el-dialog :title="$t('general.add')" :append-to-body="true" :visible.sync="dialogVisible" width="60%" :before-close="handleClose">
      <el-form :model="inputForm" :rules="rules" ref="inputForm" label-width="9rem" class="demo-inputForm" size="medium" :label-position="labelPosition" style="width: 94%; margin-left: 3%; margin-right: 3%;">
        <el-input type="hidden" v-model="inputForm.id" />

        <el-row :gutter=50>
          <el-col :md=12>
            <el-form-item :label="$t('general.date')+':'" prop="date">
              <el-date-picker v-model="inputForm.date" size="mini" value-format="yyyy-MM-dd" type="date" style="width: 100%;" :placeholder="$t('general.please_select')">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :md=12>
            <el-form-item label="備考">
              <el-input v-model="inputForm.remark" size=mini prefix-icon="el-icon-edit"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter=50>
          <el-col :md=12>
            <el-form-item :label="$t('companyInfo.name')+':'" prop="company_id">
              <el-select v-model="inputForm.company_id" clearable size="mini" :empty-text="$t('general.empty_data')" :placeholder="$t('general.please_select')" style="width: 100%;">
                <el-option v-for="item in companyInfo" :key="item.id" :label="item.name1" :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :md=12>
            <el-form-item label="事業主確認日:">
              <el-date-picker v-model="inputForm.confirmDate" size="mini" value-format="yyyy-MM-dd" type="date" style="width: 100%;" :placeholder="$t('general.please_select')">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter=50>
          <el-col :md=12>
            <el-form-item :label="$t('general.employee_id') + ':'" prop="employee_id">
              <el-select v-model="inputForm.employee_id" clearable size="mini" :empty-text="$t('general.empty_data')" :placeholder="$t('general.please_select')" style="width: 100%;">
                <el-option v-for="item in empList" :key="item.id" :label="item.employee_id" :value="item.employee_id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :md=12>
            <el-form-item :label="$t('empList.name') + ':'" prop="employee_id">
              <el-select v-model="inputForm.employee_id" clearable size="mini" :empty-text="$t('general.empty_data')" :placeholder="$t('general.please_select')" style="width: 100%;">
                <el-option v-for="item in empList" :key="item.id" :label="item.name" :value="item.employee_id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter=50>
          <el-col :md=12>
            <el-form-item label="育児休業開始日:" prop="leaveStartDate">
              <el-date-picker v-model="inputForm.leaveStartDate" size="mini" value-format="yyyy-MM-dd" type="date" style="width: 100%;" :placeholder="$t('general.please_select')">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :md=12>
            <el-form-item label="出産日:">
              <el-date-picker v-model="inputForm.dueDate" size="mini" value-format="yyyy-MM-dd" type="date" style="width: 100%;" :placeholder="$t('general.please_select')">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item label="その１：">
          <div class="borderBox">
            <el-row>
              <el-form-item label="支給単位期間">
                <el-date-picker v-model="inputForm.paymentPeriodStart1" size="mini" value-format="yyyy-MM-dd" type="date" style="width: 45%" :placeholder="$t('general.please_select')">
                </el-date-picker>
                ～
                <el-date-picker v-model="inputForm.paymentPeriodEnd1" size="mini" value-format="yyyy-MM-dd" type="date" style="width: 45%" :placeholder="$t('general.please_select')">
                </el-date-picker>
              </el-form-item>
            </el-row>

            <el-row>
              <el-form-item label="支払われた賃金額">
                <el-input-number v-model="inputForm.payment1" size=mini controls-position="right" :min="0" :step="1000" style="width: 100%;"></el-input-number>
              </el-form-item>
            </el-row>

            <el-row :gutter=30>
              <el-col :md=12>
                <el-form-item label="就業日数">
                  <el-input-number v-model="inputForm.workingDay1" size=mini controls-position="right" :min="0" style="width: 100%;" :step="5"></el-input-number>
                </el-form-item>
              </el-col>

              <el-col :md=12>
                <el-form-item label="就業時間">
                  <el-input-number v-model="inputForm.workingHour1" size=mini controls-position="right" :min="0" :step="10" style="width: 100%;">
                  </el-input-number>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </el-form-item>

        <el-form-item label="その２：">
          <div class="borderBox">
            <el-row>
              <el-form-item label="支給単位期間">
                <el-date-picker v-model="inputForm.paymentPeriodStart2" size="mini" value-format="yyyy-MM-dd" type="date" style="width: 45%" :placeholder="$t('general.please_select')">
                </el-date-picker>
                ～
                <el-date-picker v-model="inputForm.paymentPeriodEnd2" size="mini" value-format="yyyy-MM-dd" type="date" style="width: 45%" :placeholder="$t('general.please_select')">
                </el-date-picker>
              </el-form-item>
            </el-row>

            <el-row>
              <el-form-item label="支払われた賃金額">
                <el-input-number v-model="inputForm.payment2" size=mini controls-position="right" :min="0" :step="1000" style="width: 100%;"></el-input-number>
              </el-form-item>
            </el-row>

            <el-row :gutter=30>
              <el-col :md=12>
                <el-form-item label="就業日数">
                  <el-input-number v-model="inputForm.workingDay2" size=mini controls-position="right" :min="0" style="width: 100%;" :step="5"></el-input-number>
                </el-form-item>
              </el-col>

              <el-col :md=12>
                <el-form-item label="就業時間">
                  <el-input-number v-model="inputForm.workingHour2" size=mini controls-position="right" :min="0" :step="10" style="width: 100%;">
                  </el-input-number>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </el-form-item>

        <el-form-item label="その３：">
          <div class="borderBox">
            <el-row>
              <el-form-item label="支給単位期間">
                <el-date-picker v-model="inputForm.paymentPeriodStart3" size="mini" value-format="yyyy-MM-dd" type="date" style="width: 45%" :placeholder="$t('general.please_select')">
                </el-date-picker>
                ～
                <el-date-picker v-model="inputForm.paymentPeriodEnd3" size="mini" value-format="yyyy-MM-dd" type="date" style="width: 45%" :placeholder="$t('general.please_select')">
                </el-date-picker>
              </el-form-item>
            </el-row>

            <el-row>
              <el-form-item label="支払われた賃金額">
                <el-input-number v-model="inputForm.payment3" size=mini controls-position="right" :min="0" :step="1000" style="width: 100%;"></el-input-number>
              </el-form-item>
            </el-row>

            <el-row :gutter=30>
              <el-col :md=12>
                <el-form-item label="就業日数">
                  <el-input-number v-model="inputForm.workingDay3" size=mini controls-position="right" :min="0" style="width: 100%;" :step="5"></el-input-number>
                </el-form-item>
              </el-col>

              <el-col :md=12>
                <el-form-item label="就業時間">
                  <el-input-number v-model="inputForm.workingHour3" size=mini controls-position="right" :min="0" :step="10" style="width: 100%;">
                  </el-input-number>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </el-form-item>

        <el-row :gutter=24>
          <el-col :md=11>
            <el-form-item label="職場復帰年月日:">
              <el-date-picker v-model="inputForm.returnDate" size="mini" value-format="yyyy-MM-dd" type="date" style="width: 100%;" :placeholder="$t('general.please_select')">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :md=6>
            <el-form-item label="配偶者育休取得:">
              <el-checkbox v-model="inputForm.spouseLeave" size=mini></el-checkbox>
            </el-form-item>
          </el-col>
          <el-col :md=7>
            <el-form-item label-width=0% prop="spouseInsNo">
              <el-input v-model="inputForm.spouseInsNo" size=mini prefix-icon="el-icon-edit" placeholder="配偶者の被保険者番号" v-if="inputForm.spouseLeave" :maxlength="11"></el-input>
            </el-form-item>
          </el-col>

        </el-row>

        <el-form-item label="支給対象となる期間の延長:" label-width="12rem">
          <div class="borderBox">

            <el-form-item label="事由:" label-width="4rem">
              <el-select v-model="inputForm.extendReason" :placeholder="$t('general.select')" clearable size="mini" style="width: 100%">
                <el-option v-for="item in reason" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="期間:" label-width="4rem">
              <el-date-picker v-model="inputForm.extendStart" size="mini" value-format="yyyy-MM-dd" type="date" style="width: 45%" :placeholder="$t('general.please_select')">
              </el-date-picker>
              ～
              <el-date-picker v-model="inputForm.extendEnd" size="mini" value-format="yyyy-MM-dd" type="date" style="width: 45%" :placeholder="$t('general.please_select')">
              </el-date-picker>
            </el-form-item>
          </div>
        </el-form-item>

      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button style="width:120px" @click="add('inputForm')" type="primary" size="medium">
          {{$t("general.confirm")}}
        </el-button>
        <el-button style="width:120px" @click="cancel()" size="medium">
          {{$t("general.cancel")}}
        </el-button>
      </span>
    </el-dialog>

    <!-- edit -->
    <el-dialog :title="$t('general.edit')" :append-to-body="true" :visible.sync="dialogEdit" width="60%" :before-close="handleClose">
      <el-form :model="inputForm" :rules="rules" ref="inputForm" label-width="9rem" class="demo-inputForm" size="medium" :label-position="labelPosition" style="width: 94%; margin-left: 3%; margin-right: 3%;">
        <el-input type="hidden" v-model="inputForm.id" />

        <el-row :gutter=50>
          <el-col :md=12>
            <el-form-item :label="$t('general.date')+':'" prop="date">
              <el-date-picker v-model="inputForm.date" size="mini" value-format="yyyy-MM-dd" type="date" style="width: 100%;" :placeholder="$t('general.please_select')">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :md=12>
            <el-form-item label="備考">
              <el-input v-model="inputForm.remark" size=mini prefix-icon="el-icon-edit"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter=50>
          <el-col :md=12>
            <el-form-item :label="$t('companyInfo.name')+':'" prop="company_id">
              <el-select v-model="inputForm.company_id" size="mini" :empty-text="$t('general.empty_data')" :placeholder="$t('general.please_select')" style="width: 100%;">
                <el-option v-for="item in companyInfo" :key="item.id" :label="item.name1" :value="item.id" disabled>
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :md=12>
            <el-form-item label="事業主確認日:">
              <el-date-picker v-model="inputForm.confirmDate" size="mini" value-format="yyyy-MM-dd" type="date" style="width: 100%;" :placeholder="$t('general.please_select')">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter=50>
          <el-col :md=12>
            <el-form-item :label="$t('general.employee_id') + ':'" prop="employee_id">
              <el-select v-model="inputForm.employee_id" clearable size="mini" :empty-text="$t('general.empty_data')" :placeholder="$t('general.please_select')" style="width: 100%;">
                <el-option v-for="item in empList" :key="item.id" :label="item.employee_id" :value="item.employee_id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :md=12>
            <el-form-item :label="$t('empList.name') + ':'" prop="employee_id">
              <el-select v-model="inputForm.employee_id" clearable size="mini" :empty-text="$t('general.empty_data')" :placeholder="$t('general.please_select')" style="width: 100%;">
                <el-option v-for="item in empList" :key="item.id" :label="item.name" :value="item.employee_id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter=50>
          <el-col :md=12>
            <el-form-item label="育児休業開始日:" prop="leaveStartDate">
              <el-date-picker v-model="inputForm.leaveStartDate" size="mini" value-format="yyyy-MM-dd" type="date" style="width: 100%;" :placeholder="$t('general.please_select')">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :md=12>
            <el-form-item label="出産日:">
              <el-date-picker v-model="inputForm.dueDate" size="mini" value-format="yyyy-MM-dd" type="date" style="width: 100%;" :placeholder="$t('general.please_select')">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item label="その１：">
          <div class="borderBox">
            <el-row>
              <el-form-item label="支給単位期間">
                <el-date-picker v-model="inputForm.paymentPeriodStart1" size="mini" value-format="yyyy-MM-dd" type="date" style="width: 45%" :placeholder="$t('general.please_select')">
                </el-date-picker>
                ～
                <el-date-picker v-model="inputForm.paymentPeriodEnd1" size="mini" value-format="yyyy-MM-dd" type="date" style="width: 45%" :placeholder="$t('general.please_select')">
                </el-date-picker>
              </el-form-item>
            </el-row>

            <el-row>
              <el-form-item label="支払われた賃金額">
                <el-input-number v-model="inputForm.payment1" size=mini controls-position="right" :min="0" :step="1000" style="width: 100%;"></el-input-number>
              </el-form-item>
            </el-row>

            <el-row :gutter=30>
              <el-col :md=12>
                <el-form-item label="就業日数">
                  <el-input-number v-model="inputForm.workingDay1" size=mini controls-position="right" :min="0" style="width: 100%;" :step="5"></el-input-number>
                </el-form-item>
              </el-col>

              <el-col :md=12>
                <el-form-item label="就業時間">
                  <el-input-number v-model="inputForm.workingHour1" size=mini controls-position="right" :min="0" :step="10" style="width: 100%;">
                  </el-input-number>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </el-form-item>

        <el-form-item label="その２：">
          <div class="borderBox">
            <el-row>
              <el-form-item label="支給単位期間">
                <el-date-picker v-model="inputForm.paymentPeriodStart2" size="mini" value-format="yyyy-MM-dd" type="date" style="width: 45%" :placeholder="$t('general.please_select')">
                </el-date-picker>
                ～
                <el-date-picker v-model="inputForm.paymentPeriodEnd2" size="mini" value-format="yyyy-MM-dd" type="date" style="width: 45%" :placeholder="$t('general.please_select')">
                </el-date-picker>
              </el-form-item>
            </el-row>

            <el-row>
              <el-form-item label="支払われた賃金額">
                <el-input-number v-model="inputForm.payment2" size=mini controls-position="right" :min="0" :step="1000" style="width: 100%;"></el-input-number>
              </el-form-item>
            </el-row>

            <el-row :gutter=30>
              <el-col :md=12>
                <el-form-item label="就業日数">
                  <el-input-number v-model="inputForm.workingDay2" size=mini controls-position="right" :min="0" style="width: 100%;" :step="5"></el-input-number>
                </el-form-item>
              </el-col>

              <el-col :md=12>
                <el-form-item label="就業時間">
                  <el-input-number v-model="inputForm.workingHour2" size=mini controls-position="right" :min="0" :step="10" style="width: 100%;">
                  </el-input-number>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </el-form-item>

        <el-form-item label="その３：">
          <div class="borderBox">
            <el-row>
              <el-form-item label="支給単位期間">
                <el-date-picker v-model="inputForm.paymentPeriodStart3" size="mini" value-format="yyyy-MM-dd" type="date" style="width: 45%" :placeholder="$t('general.please_select')">
                </el-date-picker>
                ～
                <el-date-picker v-model="inputForm.paymentPeriodEnd3" size="mini" value-format="yyyy-MM-dd" type="date" style="width: 45%" :placeholder="$t('general.please_select')">
                </el-date-picker>
              </el-form-item>
            </el-row>

            <el-row>
              <el-form-item label="支払われた賃金額">
                <el-input-number v-model="inputForm.payment3" size=mini controls-position="right" :min="0" :step="1000" style="width: 100%;"></el-input-number>
              </el-form-item>
            </el-row>

            <el-row :gutter=30>
              <el-col :md=12>
                <el-form-item label="就業日数">
                  <el-input-number v-model="inputForm.workingDay3" size=mini controls-position="right" :min="0" style="width: 100%;" :step="5"></el-input-number>
                </el-form-item>
              </el-col>

              <el-col :md=12>
                <el-form-item label="就業時間">
                  <el-input-number v-model="inputForm.workingHour3" size=mini controls-position="right" :min="0" :step="10" style="width: 100%;">
                  </el-input-number>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </el-form-item>

        <el-row :gutter=24>
          <el-col :md=11>
            <el-form-item label="職場復帰年月日:">
              <el-date-picker v-model="inputForm.returnDate" size="mini" value-format="yyyy-MM-dd" type="date" style="width: 100%;" :placeholder="$t('general.please_select')">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :md=6>
            <el-form-item label="配偶者育休取得:">
              <el-checkbox v-model="inputForm.spouseLeave" size=mini></el-checkbox>
            </el-form-item>
          </el-col>
          <el-col :md=7>
            <el-form-item label-width=0% prop="spouseInsNo">
              <el-input v-model="inputForm.spouseInsNo" size=mini prefix-icon="el-icon-edit" placeholder="配偶者の被保険者番号" v-if="inputForm.spouseLeave" :maxlength="11"></el-input>
              <!-- </el-input-number> -->
            </el-form-item>
          </el-col>

        </el-row>

        <el-form-item label="支給対象となる期間の延長:" label-width="12rem">
          <div class="borderBox">

            <el-form-item label="事由:" label-width="4rem">
              <el-select v-model="inputForm.extendReason" :placeholder="$t('general.select')" clearable size="mini" style="width: 100%">
                <el-option v-for="item in reason" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="期間:" label-width="4rem">
              <el-date-picker v-model="inputForm.extendStart" size="mini" value-format="yyyy-MM-dd" type="date" style="width: 45%" :placeholder="$t('general.please_select')">
              </el-date-picker>
              ～
              <el-date-picker v-model="inputForm.extendEnd" size="mini" value-format="yyyy-MM-dd" type="date" style="width: 45%" :placeholder="$t('general.please_select')">
              </el-date-picker>
            </el-form-item>
          </div>
        </el-form-item>

      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button style="width:120px" @click="edit('inputForm')" type="primary" size="medium">
          {{$t("general.confirm")}}
        </el-button>
        <el-button style="width:120px" @click="cancel()" size="medium">
          {{$t("general.cancel")}}
        </el-button>
      </span>
    </el-dialog>

    <div style="text-align: left; margin-top: 50vh; font-size: smaller;">
      <el-row :gutter="40">
        <el-col :md=12>
          <el-card style="background-color: #51d1ff1c;">
            育児休業給付についての詳しくは
            <el-link href="https://www.mhlw.go.jp/file/06-Seisakujouhou-11600000-Shokugyouanteikyoku/0000172768.pdf" target="_blank" style="font-size: small; font-weight: bold; color: rgb(0, 0, 0);">
              こちら
            </el-link>
            をご覧ください。

          </el-card>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {

  data() {

    return {
      pageSize: 6,
      currentPage: 1,
      total: 0,
      disablePage: false,

      labelPosition: "left",

      dialogVisible: false,
      dialogEdit: false,

      tableData: [],
      companyInfo: [],
      empList: [],

      inputForm: {
        id: "",
        company_id: "",
        employee_id: "",
        confirmDate: "",
        leaveStartDate: "",
        dueDate: "",

        paymentPeriodStart1: "",
        paymentPeriodEnd1: "",
        workingDay1: "",
        workingHour1: "",
        payment1: "",

        paymentPeriodStart2: "",
        paymentPeriodEnd2: "",
        workingDay2: "",
        workingHour2: "",
        payment2: "",

        paymentPeriodStart3: "",
        paymentPeriodEnd3: "",
        workingDay3: "",
        workingHour3: "",
        payment3: "",

        returnDate: "",
        extendReason: "",
        extendStart: "",
        extendEnd: "",

        spouseLeave: false,
        spouseInsNo: "",

        date: "",
        remark: ""
      },

      rules: {
        date: [{
          required: true,
          message: this.$t("general.please_select"),
          trigger: "blur",
        },],
        company_id: [{
          required: true,
          message: this.$t("general.please_select"),
          trigger: "blur",
        },],
        employee_id: [{
          required: true,
          message: this.$t("general.please_select"),
          trigger: "blur",
        },],
        leaveStartDate: [{
          required: true,
          message: this.$t("general.please_select"),
          trigger: "blur",
        },],
        spouseInsNo: [{
          // validator: checkNo,
          pattern: /[0-9]{11}/,
          message: "数字１１桁入力してください",
          trigger: "blur"
        }],
      },

      reason: [{
        value: "保育所における保育が実産されないこと",
        label: "保育所における保育が実産されないこと",
      }, {
        value: "養育予定していた配偶者の死亡",
        label: "養育予定していた配偶者の死亡",
      }, {
        value: "養育予定していた配偶者の負傷・疾病等",
        label: "養育予定していた配偶者の負傷・疾病等",
      }, {
        value: "養育予定していた配偶者との婚姻の解消等による別居",
        label: "養育予定していた配偶者との婚姻の解消等による別居",
      }, {
        value: "養育予定していた配偶者の産前産後休業等",
        label: "養育予定していた配偶者の産前産後休業等",
      },],
    };
  },
  methods: {

    preview(row) {
      var uid = window.localStorage.getItem('LoginUserId');
      window.open(
        "/pdf/育児休業給付受給資格確認票・（初回）育児休業給付金支給申請書-" + row.empName + row.date + ".pdf"
      );
    },

    printPDF(index, row) {
      let postData = this.qs.stringify({
        id: row.id
      });
      this.axios({
        method: "post",
        url: "/empInsChildcareLeavePDF",
        data: postData
      })
        .then((response) => {
          console.log(response)
          if (response.data.status = "success") {
            this.$message({
              type: "success",
              message: this.$t("general.print_completed")
            });
            setTimeout(() => {
              this.preview(row);
            }, 300);
          } else {
            this.$message({
              type: "warning",
              message: this.$t("general.print_failed")
            });
          }
        })
        .catch(error => {
          this.$message({
            type: "warning",
            message: this.$t("general.print_failed")
          });
          // console.log(error);
        });
    },


    add(form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          let postData = this.qs.stringify({
            company_id: this.inputForm.company_id,
            employee_id: this.inputForm.employee_id,
            confirmDate: this.inputForm.confirmDate,
            leaveStartDate: this.inputForm.leaveStartDate,
            dueDate: this.inputForm.dueDate,

            paymentPeriodStart1: this.inputForm.paymentPeriodStart1,
            paymentPeriodEnd1: this.inputForm.paymentPeriodEnd1,
            workingDay1: this.inputForm.workingDay1,
            workingHour1: this.inputForm.workingHour1,
            payment1: this.inputForm.payment1,

            paymentPeriodStart2: this.inputForm.paymentPeriodStart2,
            paymentPeriodEnd2: this.inputForm.paymentPeriodEnd2,
            workingDay2: this.inputForm.workingDay2,
            workingHour2: this.inputForm.workingHour2,
            payment2: this.inputForm.payment2,

            paymentPeriodStart3: this.inputForm.paymentPeriodStart3,
            paymentPeriodEnd3: this.inputForm.paymentPeriodEnd3,
            workingDay3: this.inputForm.workingDay3,
            workingHour3: this.inputForm.workingHour3,
            payment3: this.inputForm.payment3,

            returnDate: this.inputForm.returnDate,
            extendReason: this.inputForm.extendReason,
            extendStart: this.inputForm.extendStart,
            extendEnd: this.inputForm.extendEnd,

            spouseLeave: this.inputForm.spouseLeave,
            spouseInsNo: this.inputForm.spouseInsNo,

            date: this.inputForm.date,
            remark: this.inputForm.remark
          });
          this.axios({
            method: "post",
            url: "/insertEmpInsChildcareLeave",
            data: postData
          })
            .then(response => {
              this.$message({
                type: "success",
                message: this.$t("general.add_completed")
              });
              this.currentPage = 1;
              this.getPages();
              this.dialogVisible = false;
              this.emptyForm();
            })
            .catch(error => {
              this.$message({
                type: "warning",
                message: this.$t("general.add_failed")
              });
              console.log(error);
            });
        } else {
          this.$message({
            type: "error",
            message: this.$t("general.valid_failed")
          });
          return false;
        }
      });
    },

    handleEdit(index, row) {
      this.dialogEdit = true;
      this.inputForm = Object.assign({}, row);
    },

    edit(form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          let postData = this.qs.stringify({
            id: this.inputForm.id,
            employee_id: this.inputForm.employee_id,
            confirmDate: this.inputForm.confirmDate,
            leaveStartDate: this.inputForm.leaveStartDate,
            dueDate: this.inputForm.dueDate,

            paymentPeriodStart1: this.inputForm.paymentPeriodStart1,
            paymentPeriodEnd1: this.inputForm.paymentPeriodEnd1,
            workingDay1: this.inputForm.workingDay1,
            workingHour1: this.inputForm.workingHour1,
            payment1: this.inputForm.payment1,

            paymentPeriodStart2: this.inputForm.paymentPeriodStart2,
            paymentPeriodEnd2: this.inputForm.paymentPeriodEnd2,
            workingDay2: this.inputForm.workingDay2,
            workingHour2: this.inputForm.workingHour2,
            payment2: this.inputForm.payment2,

            paymentPeriodStart3: this.inputForm.paymentPeriodStart3,
            paymentPeriodEnd3: this.inputForm.paymentPeriodEnd3,
            workingDay3: this.inputForm.workingDay3,
            workingHour3: this.inputForm.workingHour3,
            payment3: this.inputForm.payment3,

            returnDate: this.inputForm.returnDate,
            extendReason: this.inputForm.extendReason,
            extendStart: this.inputForm.extendStart,
            extendEnd: this.inputForm.extendEnd,

            spouseLeave: this.inputForm.spouseLeave,
            spouseInsNo: this.inputForm.spouseInsNo,

            date: this.inputForm.date,
            remark: this.inputForm.remark
          });
          this.axios({
            method: "post",
            url: "/updateEmpInsChildcareLeave",
            data: postData
          })
            .then(response => {
              this.handleCurrentChange();
              this.dialogEdit = false;
              this.emptyForm();
              this.$message({
                type: "success",
                message: this.$t("general.edit_completed")
              });
              // console.log(response);
            })
            .catch(error => {
              this.$message({
                type: "warning",
                message: this.$t("general.edit_failed")
              });
              console.log(error);
            });
        } else {
          console.log("error submit!!");
          this.$message({
            type: "error",
            message: this.$t("general.valid_failed")
          });
          return false;
        }
      });
    },

    handleDelete(index, row) {
      this.$confirm(this.$t("general.sure_delete"), this.$t("general.hint"), {
        cancelButtonClass: "btn-custom-cancel",
        confirmButtonClass: "btn-custom-confirm",
        confirmButtonText: "OK",
        cancelButtonText: this.$t("general.cancel"),
        type: "warning"
      })
        .then(() => {
          let postData = this.qs.stringify({
            id: row.id
          });
          this.axios({
            method: "post",
            url: "/deleteEmpInsChildcareLeave",
            data: postData
          })
            .then(response => {
              this.getPages();
              this.$message({
                type: "success",
                message: this.$t("general.delete_completed")
              });
            })
            .catch(error => {
              console.log(error);
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: this.$t("general.canceled")
          });
        });
    },

    jump(path) {
      this.$router.push(path);
    },

    cancel() {
      this.dialogVisible = false;
      this.dialogEdit = false;
      this.emptyForm();
    },

    emptyForm() {
      this.inputForm = {
        id: "",
        company_id: "",
        employee_id: "",
        confirmDate: "",
        leaveStartDate: "",
        dueDate: "",

        paymentPeriodStart1: "",
        paymentPeriodEnd1: "",
        workingDay1: "",
        workingHour1: "",
        payment1: "",

        paymentPeriodStart2: "",
        paymentPeriodEnd2: "",
        workingDay2: "",
        workingHour2: "",
        payment2: "",

        paymentPeriodStart3: "",
        paymentPeriodEnd3: "",
        workingDay3: "",
        workingHour3: "",
        payment3: "",

        returnDate: "",
        extendReason: "",
        extendStart: "",
        extendEnd: "",

        spouseLeave: false,
        spouseInsNo: "",

        date: "",
        remark: ""
      }
      this.$refs['inputForm'].resetFields();
    },

    handleClose(done) {
      this.$confirm(this.$t("general.close_comfirm"), {
        cancelButtonClass: "btn-custom-cancel",
        confirmButtonClass: "btn-custom-confirm",
        confirmButtonText: this.$t("general.confirm"),
        cancelButtonText: this.$t("general.cancel"),
        type: "warning"
      })
        .then(_ => {
          done();
          this.emptyForm();
        })
        .catch(_ => { });
    },

    handleCurrentChange() {
      let postData = this.qs.stringify({
        page: this.currentPage
      });
      this.axios({
        method: "post",
        url: "/pageEmpInsChildcareLeave",
        data: postData
      })
        .then(response => {
          this.tableData = response.data;
        })
        .catch(error => {
          console.log(error);
        });
    },

    getPages() {
      this.axios
        .post("/pageEmpInsChildcareLeave")
        .then(response => {
          this.show = true
          this.tableData = response.data;
        })
        .catch(error => {
          this.show = false;
          this.$message({
            type: 'error',
            message: '開発中です。'
          });
          console.log(error);
        });
      this.axios
        .post("/rowsEmpInsChildcareLeave")
        .then(response => {
          this.total = response.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
  },

  created() {
    this.getPages();

    //get Company List
    this.axios
      .post("/ListComInfo")
      .then((response) => {
        this.companyInfo = response.data;
        console.log(this.companyInfo);
      })
      .catch((error) => {
        console.log(error);
      });

    //get Employee Name
    this.axios
      .post("/ListEmpListForInsNameChange")
      .then(response => {
        this.empList = response.data;
      })
      .catch(error => {
        console.log(error);
      });
  }
};
</script>

<style scoped>
.style1 {
  margin-right: 100px;
  padding: 0px;
  text-align: right;
}

.pages {
  margin: 0px;
  padding: 0px;
  text-align: right;
}

.borderBox {
  background-color: #eff0f0a6;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  /* border: rgb(204, 204, 204) 1px solid; */
  padding: 2%;
}

.boxHeader {
  font-size: large;
  font-weight: bold;
  font-family: Microsoft YaHei;
  letter-spacing: 3px;
}
</style>


// WEBPACK FOOTER //
// src/components/EmpIns/EmpInsChildcareLeave.vue